import { remoteConfig } from '@/utils/remoteConfig'
import { getValue } from 'firebase/remote-config'

/** Remote Config switches of the Microsoft login rollout (all default to false). */
export const AUTH_FLAGS = {
    msLoginEnabled: 'ms_login_enabled',
    bulkLinkEnabled: 'ms_bulk_link_enabled',
    passwordRestricted: 'auth_password_restricted',
} as const

export type AuthFlag = keyof typeof AUTH_FLAGS

export const isAuthFlagEnabled = (flag: AuthFlag): boolean => {
    try {
        return getValue(remoteConfig, AUTH_FLAGS[flag]).asBoolean()
    } catch {
        return false
    }
}
